import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle(({ theme }) => ({
  body: theme.body,
  a: theme.link.default,
  'a:hover': theme.link.hover,
}))
